<template>
  <div class="grid row">
    <div class="flex xs12">
      <va-card title="Редагування Gallery Item" class="fill-height">
        <div>
          <div class="row">
            <div class="flex xs12">
              <va-tabs v-model="tabValue" style="width: 100%; min-width: 250px; margin-bottom: 25px;">
                <va-tab
                  v-for="title in tabTitles"
                  :key="title"
                >
                  {{title}}
                </va-tab>
              </va-tabs>
              <div class="flex xs12" v-if="tabValue === 0">
                <va-input
                  label="Label *"
                  v-model="label"
                  @input="delete errors.label"
                  :error="!!errors.label"
                  :error-messages="errors.label"
                />
                <va-card class="mb-3" title="Image">
                  <div v-if="imageExisting">
                    <a style="display: block;" target="_blank" :href="imageExisting"><img style="max-width: 400px;" :src="imageExisting"></a>
                    <div><va-button small color="danger" @click="imageExisting = deleteImage(imageId) ? '' : imageExisting">Видалити</va-button></div>
                  </div>
                  <span>Завантажити нове зображення</span>
                  <va-file-upload
                    type="gallery"
                    dropzone
                    @input="delete errors.image"
                    v-model="image"
                    style="margin-bottom: 25px;"
                  />
                  <va-button @click="uploadImage('Gallery[image]','GalleryImage', 'image', image[0])">Завантажити</va-button>
                  <div v-if="errors.image" style="color: red;">{{ errors.image[0] }}</div>
                </va-card>
                <va-card class="mb-3" title="Video">
                  <div v-if="videoExisting">
                    <a class="link" style="display: block;" target="_blank" :href="videoExisting">{{ videoExisting }}</a>
                    <div><va-button small color="danger" @click="videoExisting = deleteImage(videoId) ? '' : videoExisting">Видалити</va-button></div>
                  </div>
                  <span>Завантажити новий файл</span>
                  <va-file-upload
                    dropzone
                    v-model="video"
                    style="margin-bottom: 25px;"
                  />
                  <va-button @click="uploadImage('Gallery[video]', 'GalleryVideo', 'video', video[0])">Завантажити</va-button>
                </va-card>
                <va-select
                  label="Category"
                  v-model="category"
                  :options="categories"
                  textBy="label"
                  :error="!!errors.category_id"
                  @input="delete errors.category_id"
                />
                <va-toggle label="Published" small v-model="published"/>
                <va-input
                  label="Position"
                  v-model.number="position"
                  @input="delete errors.position"
                  :error="!!errors.position"
                  :error-messages="errors.position"
                />
                <va-button @click="submit()">Save</va-button>
              </div>
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  name: 'grid',
  data () {
    return {
      label: '',
      subLabel: '',
      image: [],
      imageId: '',
      imageExisting: '',
      video: [],
      videoId: '',
      videoExisting: '',

      category: '',
      categories: [],

      published: false,
      position: '',

      sign: '',

      errors: [],

      tabTitles: ['Main'],
      tabValue: 0,
    }
  },
  created () {
    this.fetch()
    const generateRandomString = (length = 6) => Math.random().toString(20).substr(2, length)
    this.sign = generateRandomString(32)
  },
  computed: {
    computedStyle () {
      return {
        backgroundColor: this.$themes.primary,
      }
    },
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    uploadImage (param, entityAttribute, attr, file) {
      if (!file) {
        return
      }
      const formData = new FormData()
      formData.append(param, file)
      formData.append('lang', this.locale)
      formData.append('file_id', '0')
      formData.append('entity_attribute', entityAttribute)
      formData.append('attribute', attr)
      formData.append('model_name', 'backend\\modules\\gallery\\models\\Gallery')
      if (this.$attrs.id) {
        formData.append('id', this.$attrs.id)
      } else {
        formData.append('sign', this.sign)
      }
      axios.post(`${process.env.VUE_APP_AGRO_API_URL}/admin/upload?lang=${this.locale}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(response => {
          this.showToast('Successful upload')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    async deleteImage (id) {
      return axios.delete(`${process.env.VUE_APP_AGRO_API_URL}/admin/upload/${id}?lang=${this.locale}`)
        .then(() => {
          this.showToast('Successfully deleted')
        })
        .catch(() => {
          this.showToast('Error')
        })
    },
    submit () {
      const data = {
        label: this.label,
        published: this.published ? 1 : 0,
        position: this.position,
        category_id: this.category ? this.category.id : null,

        sign: this.sign ? this.sign : null,
      }
      if (this.$attrs.id) { // update
        axios.put(`${process.env.VUE_APP_AGRO_API_URL}/admin/gallery/${this.$attrs.id}?lang=${this.locale}`, data)
          .then(response => {
            this.$router.push({ name: 'agro-gallery-items' })
            this.showToast('Success')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }
            console.log(error)
            this.showToast('Error')
          })
      } else {
        axios.post(`${process.env.VUE_APP_AGRO_API_URL}/admin/gallery?lang=${this.locale}`, data)
          .then(response => {
            this.$router.push({ name: 'agro-gallery-items' })
            this.showToast('Success')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }
            console.log(error)
            this.showToast('Error')
          })
      }
    },
    fetch () {
      axios.get(`${process.env.VUE_APP_AGRO_API_URL}/admin/gallery/categories?lang=${this.locale}`)
        .then(response => {
          this.categories = response.data
          if (this.$attrs.id) {
            axios.get(`${process.env.VUE_APP_AGRO_API_URL}/admin/gallery/${this.$attrs.id}?lang=${this.locale}`)
              .then(response => {
                console.log(response.data)
                this.label = response.data.label
                this.imageExisting = response.data.image ? process.env.VUE_APP_AGRO_ADMIN + response.data.image : ''
                this.imageId = response.data.imageId
                this.videoExisting = response.data.video ? process.env.VUE_APP_AGRO_ADMIN + response.data.video : ''
                this.videoId = response.data.videoId
                if (response.data.category_id) {
                  this.category = this.categories.find(i => i.id === response.data.category_id)
                }

                this.published = !!response.data.published
                this.position = response.data.position
              })
              .catch(error => {
                console.log(error)
                this.showToast('Error')
              })
          }
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
  },
}
</script>

<style lang="scss">
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
  }
}

.va-file-upload-gallery-item {
  flex-basis: unset;
  max-width: 400px;
  width: unset;
}
</style>
